<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;"
                v-if="isLoading == true">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            <div class="card">
                <div class="card-body">
                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: left">
                                <label class="d-inline-flex align-items-center">
                                    {{ $t("label.search") }}
                                    <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                                        class="form-control form-control-sm ml-2"
                                        @change="searchListing"></b-form-input>
                                </label>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: right">
                                <a @click="toCreatePage()" style="float: right; margin-bottom: 10px"
                                    v-if="createPermission == true"
                                    class="btn btn-primary w-md waves-effect waves-light">
                                    {{ $t('label.createX', [$t('module.printerProof')]) }}
                                </a>
                                <button @click="refresh" style="margin-left: 10px;"
                                    class="btn btn-info w-md waves-effect waves-light mr-2 mb-2">
                                    <i class="fa fa-sync pl-1"></i>
                                    {{ $t('label.refresh') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive mb-0">
                        <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage"
                            v-if="readPermission == true">
                            <template #cell(isActive)="data">
                                <b-form-checkbox @change="editStatus(tableRows[data.index])"
                                    :disabled="updateStatusPermission != true" v-model="tableRows[data.index].isActive"
                                    switch class="mb-1">
                                </b-form-checkbox>
                            </template>

                            <template #cell(product)="data">
                                <span>{{ tableRows[data.index].product.name }}</span>
                            </template>

                            <template #cell(type)="data">
                                <span v-if="tableRows[data.index].type == 0">Reply</span>
                                <span v-if="tableRows[data.index].type == 1">Query</span>
                            </template>

                            <template #cell(action)="data">
                                <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                    ? 'disabled text-warning'
                                    : 'text-primary'
                                    " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                    v-if="readPermission == true && updatePermission == true" title="Edit">
                                    <i class="mdi mdi-pencil font-size-18"></i>
                                </a>

                                <a href="javascript:void(0);" :class="currentUser == tableRows[data.index].email
                                    ? 'disabled text-warning'
                                    : 'text-primary'
                                    " @click="toDetailsPage(tableRows[data.index].uuid)" v-b-tooltip.hover
                                    style="margin-left: 5px;" v-if="readPermission == true && updatePermission != true"
                                    title="Edit">
                                    <i class="mdi mdi-file-search-outline font-size-18"></i>
                                </a>
                            </template>
                        </b-table>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                    <div class="row" v-if="readPermission == true">
                        <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination v-model="currentPage" :total-rows="totalPage" :per-page="perPage"
                                        @change="pageNavigation"></b-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { mapState } from "vuex";
import { PRODUCT_PRINTER_PROOF_MODULE } from '@/state/modules/productPrinterProof'
import { productPrinterProofMethods } from "@/state/helpers";

export default {
    page: {
        title: i18n.t("label.listingX", [i18n.t('module.printerProof')]),
    },
    beforeRouteLeave(to, from, next) {
        if (to.name != 'Product-printer-proof-update' && to.name != 'Product-printer-proof-create') {
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH)
        }
        next();
    },
    props: {
        triggerSearch: {
            type: String,
            default: null,
        },
        triggerTab: {
            type: String,
            default: null,
        }
    },
    watch: {
        triggerTab(value) {
            if (value == "productPrinterProof") {
                this.initSearchCriteria();
            }
        }
    },
    data() {
        return {
            title: i18n.t("label.listingX", [i18n.t('module.printerProof')]),
            items: [
                {
                    text: i18n.t("module.dashboard"),
                    href: "/",
                },
                {
                    text: i18n.t("module.printerProof"),
                    active: true,
                },
            ],
            statusDdl: ddlHelper.getActivationStatus(true),
            accountLockStatusDdl: ddlHelper.getAccountLockStatus(true),
            currentUser: sessionHelper.getUserEmail(),
            currentPage: 1,
            filter: "",
            isLoading: null,
            enabled: false,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            permissions: sessionHelper.getPermissions(),
            pageOptions: [10, 25, 50, 100],
            filterOn: [],
            sortBy: "name",
            updatePermission: null,
            updateStatusPermission: null,
            readPermission: null,
            createPermission: null,
            fields: [
                { key: "product", sortable: true, label: i18n.t("module.product"), },
                { key: "type", sortable: true, label: i18n.t("label.type") },
                { key: "date", sortable: true, label: i18n.t("label.date") },
                { key: "isActive", sortable: true, label: i18n.t("label.recordStatus") },
                { key: "Action", sortable: false, label: i18n.t("label.action"), },
            ],
        };
    },
    computed: {
        ...mapState(PRODUCT_PRINTER_PROOF_MODULE, ['status']),
        tableRows() {
            return this.$store.state.productPrinterProof.list.data;
        },
        pagination() {
            return this.$store.state.productPrinterProof.list.pagination;
        },
        totalPage() {
            return this.$store.state.productPrinterProof.list.pagination.total;
        },
    },
    mounted() { },
    methods: {
        ...productPrinterProofMethods,
        async initSearchCriteria() {
            let isDefault = true;

            var jsonPermissions = JSON.parse(this.permissions);

            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPR")) {
                this.readPermission = true;
            }
            else {
                this.readPermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPU")) {
                this.updatePermission = true;
            }
            else {
                this.updatePermission = false;
            }

            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPUS")) {
                this.updateStatusPermission = true;
            }
            else {
                this.updateStatusPermission = false;
            }

            if (sessionHelper.hasSearchCriteria(SESSION.PRODUCT_AI_SEARCH)) {
                isDefault = false;
                this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_AI_SEARCH);
                this.currentPage = this.searchCriteria.pageNumber;
                this.searchCriteria.isActive = 1;
            }

            if (isDefault) {
                this.searchCriteria = {
                    pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                    pageSize: SHARED.DEFAULT_PAGE_SIZE,
                    isActive: 1,
                    isLocked: this.accountLockStatusDdl[0].value,
                    product: this.triggerSearch,
                    searchValue: "",
                    searchArray: [],
                };
            }
            else {
                this.searchCriteria.product = this.triggerSearch
            }

            await this.getPrinterList(this.searchCriteria);
        },

        async getPrinterList(filter) {
            this.isLoading = true;
            await this.getAllProductPrinterProofs({ filter });
            // this.$store.dispatch(`user/getAllUser`, { filter });
            this.searchCriteria = filter;
            sessionHelper.storeSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH, filter);
            this.isLoading = false;
        },

        pageNavigation(pageNumber) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            filter.pageNumber = pageNumber;

            this.getPrinterList(filter);
        },

        refresh() {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
            this.getPrinterList(filter);
        },

        toDetailsPage(id) {
            let filter = sessionHelper.retrieveSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH)
            filter.selectedRecordId = id
            sessionHelper.storeSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH, filter)

            filter.isCloseWhenSuccess = true
            sessionHelper.storeSearch(SESSION.PRODUCT_SPECIAL_SEARCH, filter)

            const routeData = this.$router.resolve({
                name: 'Product-printer-proof-update',
            })

            window.open(routeData.href, '_blank')

        },

        toCreatePage() {
            let filter = {
                selectedRecordId: this.triggerSearch
            }
            sessionHelper.storeSearch(SESSION.PRODUCT_SPECIAL_SEARCH, filter)

            const routeData = this.$router.resolve({
                name: 'Product-printer-proof-create',
            })

            window.open(routeData.href, '_blank') // 👈 open in new tab
        },


        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;

            this.searchCriteria.searchArray = [];
            this.searchCriteria.searchArray.push(this.filter);
            if (this.filter == '' || this.filter == null) {
                this.searchCriteria.pageNumber = 1;
                this.currentPage = 1;
            }
            this.getPrinterList(this.searchCriteria);
        },

        editStatus(user) {
            const data = {
                id: user.uuid,
                isActive: user.isActive,
            };

            this.updateProductPrinterProofStatus({ filter: this.searchCriteria, data });
        },
    },
};
</script>